import { useEffect, useState } from 'react';

import { CURRENCIES } from '@splitfiesta/i18n';

import {
  type BrowserDefaults,
  browserDetectionService,
} from '@/services/browser/BrowserDetectionService';

export function useBrowserDefaults() {
  const [defaults, setDefaults] = useState<BrowserDefaults>({
    language: 'en',
    currency: '',
  });

  useEffect(() => {
    // Only run on client side
    if (!browserDetectionService.isBrowser()) return;

    try {
      // Get list of supported currencies
      const supportedCurrencies = Object.keys(CURRENCIES);

      // Detect all browser defaults using the service
      const detectedDefaults =
        browserDetectionService.detectBrowserDefaults(supportedCurrencies);

      // Wrap setState in setTimeout to avoid direct state setting in effect
      const timer = setTimeout(() => {
        setDefaults(prev => {
          // If detectedDefaults is undefined, keep previous state
          if (!detectedDefaults) {
            return prev;
          }
          // Only update if values actually changed
          if (
            prev.language !== detectedDefaults.language ||
            prev.currency !== detectedDefaults.currency
          ) {
            return detectedDefaults;
          }
          return prev;
        });
      }, 0);
      return () => clearTimeout(timer);
    } catch {
      // If detection fails, keep the initial defaults
    }
  }, []);

  return defaults;
}
